<template>
    <section class="perfil-empty" v-if="notAvailableProfile">
        El perfil no se encuentra disponible
    </section>
    <section v-if="completeLoad" class="main-container">
        <h2 class="title">Resumen</h2>
        <div class="dashboard">

            <article class="dashboard__activity card card--orange">
                <div class="dashboard__card-title">
                    <i class="material-icons">bar_chart</i>
                    <span>Actividad</span>
                </div>
                <div class="card-content">
                    <div>
                        <h3>{{resume.activity.completitionPercentaje}}%</h3>
                        <h4>Completitud del perfil</h4>
                        <p>Último login: 
                            <strong v-if="resume.activity.lastLogin != null">{{formatDate(resume.activity.lastLogin)}}</strong>
                            <strong v-else>Sin información</strong>
                        </p>
                    </div>
                </div>
            </article>

            <article class="dashboard__working card">
                <div class="dashboard__card-title">
                    <i class="material-icons">work</i>
                    <span>Laboral</span>
                </div>
                <div class="dashboard__grid">
                    <div>
                        <h3>{{resume.jobSearchs.applied}}</h3>
                        <h4>Postulaciones</h4>
                    </div>
                    <div>
                        <h3>{{resume.jobSearchs.opened}}</h3>
                        <h4>Vigentes</h4>
                    </div>
                    <div>
                        <h3>{{resume.jobSearchs.viewed}}</h3>
                        <h4>Perfil visto</h4>
                    </div>
                    <div>
                        <h3>{{resume.jobSearchs.notHired}}</h3>
                        <h4>No seleccionado</h4>
                    </div>
                    <div>
                        <h3>{{resume.jobSearchs.contacted}}</h3>
                        <h4>Datos solicitados</h4>
                    </div>
                </div>
                <div class="dashboard__working__workSituation">
                    <p>
                        <!-- Situación laboral: <strong>{{$t(`forge_dashboard.profile.${resume.workSituation}`)}}</strong> -->
                        Situación laboral:<br><strong>{{$t(`forge_dashboard.profile.OWN_WORK`)}}</strong>
                    </p> 
                </div>
            </article>

            <article class="dashboard__challenges card">
                <div class="dashboard__card-title">
                    <i class="material-icons">assignment_ind</i>
                    <span>Competencias</span>
                </div>
                <div class="card-content">
                    <div class="dashboard__grid">
                        <div class="dashboard__list">
                            <img src="@/assets/arrow-green.svg" alt="">
                            <ul>
                                <li v-for="(aptitud,index) in resume.aptitudes.best" :key="index">{{aptitud}}</li>
                            </ul>
                        </div>
                        <div class="dashboard__list">
                            <img src="@/assets/arrow-orange.svg" alt="">
                            <ul>
                                <li v-for="(aptitud,index) in resume.aptitudes.worst" :key="index">{{aptitud}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </article>

            <article class="dashboard__games card">
                <div class="dashboard__card-title">
                    <i class="material-icons">build</i>
                    <span>Habilidades</span>
                </div>
                <div class="card-content">
                    <div class="dashboard__list">
                        <ul>
                            <li v-for="game in resume.games" :key="game.code">
                                <i v-if="game.status=='INPROCCESS'" class="material-icons status__in-progress">play_circle_filled</i>
                                <i v-if="game.status=='COMPLETED'" class="material-icons status__complete">check_circle</i>
                                <i v-if="game.status=='PENDING'" class="material-icons status__pending">close</i>
                                <span :style="[game.status=='PENDING' ? {'color':'#7D7D7D'} : '']">{{game.name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </article>
        </div>
    </section>
</template>

<script>
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { onMounted, ref } from 'vue';
import moment from 'moment';
import { useI18n } from 'vue-i18n';
//import { Skeletor } from 'vue-skeletor';

export default {
    setup() {
        const store = useStore();
        const route = useRoute();
        const resume = ref();
        const completeLoad = ref(false);
        const { t } = useI18n();
        const notAvailableProfile = ref(false)
        onMounted(async ()=>{
            try{
                resume.value = await store.dispatch('forgeUsers_profileResume',route.params.id);
                completeLoad.value = true;
            } catch (error) {
                if(error.response.data == 'UserDoesNotExist')
                {
                    notAvailableProfile.value = true
                }
                else
                {
                    store.dispatch('notifications_create', { text: t(`notifications.generic`) });
                }
            }
        })

        function formatDate(dateTime) {
            return moment(dateTime).isValid() ? moment(dateTime).format("DD/MM/YYYY") : "";
        }

        return{
            resume,
            notAvailableProfile,
            completeLoad,
            formatDate,
        }
    },
}
</script>

<style lang="scss" scoped>

    * {
        box-sizing: border-box;
    }

    .main-container {
        box-sizing: border-box;
        width: calc(100% - 32px);
        margin: $margin-base;
        padding: $margin-mega;
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: $margin-base;
        background: #FFFFFF;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
        border-radius: $margin-base;
    }

    .title {
        font-style: normal;
        font-weight: 600;
        font-size: 26px;
        color: #231F20;
        margin: 0;
    }

    .dashboard {
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-evenly;
        align-items: flex-start;
        gap: 8px;

        .card {
            //flex-grow: 1;
            box-sizing: border-box;
            padding: $margin-base;
            display: flex;
            flex-flow: column nowrap;
            border: 1px solid #C4C4C4;
            border-radius: $margin-milli;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            height: 370px;
            //width: fit-content;
            width: 25%;
            max-width: 380px;

            &--orange {
                border: 1px solid #E25523;
            }
        }

        &__card-title{
            gap: 4px;
            display: flex;
            align-items: flex-end;
            font-style: normal;
            font-size: 14px;
            color: #231F20;
            line-height: 14px;

            span{
                font-weight: 400;
                line-height: 21px;
            }
        }

        &__activity{
            .card-content{
                flex-grow: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                >div{
                    display: inline-flex;
                    align-self: center;
                    flex-flow: column nowrap;
                }
                h3 {
                    @include font-settings(tera, base);
                    color: #E25523;
                    text-align: center;
                    margin-bottom: 4px;
                }
    
                h4 {
                    @include font-settings(kilo, base);
                    color: #E25523;
                    text-align: center;
                }
    
                p {
                    @include font-settings(base, base);
                    text-align: center;
                    margin-bottom: $margin-kilo;
                    margin-top: $margin-base;
                }
            }
        }

        &__working{
            display: flex;
            flex-direction: column;

            .dashboard__grid {
                padding-left: 16px;
                margin-top: 32px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 12px;
                >div{
                    display: flex;
                    flex-flow: row nowrap;
                    align-items: center;
                    gap: 8px;
                }
            }

            h3 {
                padding: 0;
                margin: 0;
                font-size: 20px;
                font-weight: 700;
                color: #231F20;
                text-align: center;
            }

            h4 {
                font-size: 16px;
                font-weight: 600;
                color: #231F20;
                font-weight: 600;
                text-align: center;
            }
            &__workSituation{
                display: flex;
                justify-content: center;
                margin-top: 8px;
                padding-top: 20px;
                border-top: 1px solid #C4C4C4;
                p{
                    font-size: 16px;
                }
            }
        }

        &__challenges {
            .card-content{
                padding-left: 8px;
                flex-grow: 1;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                .dashboard__grid {
                    margin-top: 32px;
                    display: inline-flex;
                    flex-flow: column nowrap;
                    gap: 24px;
                    .dashboard__list {
                        align-items: center;
                        display: flex;
                        gap: 16px;
    
                        ul {
                            list-style: none;
    
                            li {
                                @include font-settings(base, mega);
                                font-weight: 600;
                            }
                        }
                    }
                }
            }
        }
        &__games{
            .card-content{
                margin-top: 32px;
                display: flex;
                align-items: center;
                .dashboard__list{
                    padding-left: 8px;
                    li{
                        padding: 4px 0;
                        display: flex;
                        flex-flow: row nowrap;
                        align-items: center;
                        gap: 8px;
                        span{
                            font-size: 16px;
                            font-weight: 600;
                            color: #231F20;
                        }
                    }
                }
            }
            .status{
                &__in-progress{
                    color: #FBBD44;
                }
                &__complete{
                    color: #00866E;
                }
                &__pending{
                    color: #7D7D7D;
                }
            }
        }
    }
    .perfil-empty {
        position: absolute;
        width: 100px;
        height: 50px;
        top: 50%;
        margin-top: -25px;
        text-align: center;
        font-size: 28px;
        white-space: nowrap;
        width: 100%;
    }
</style>
<style>
.custom-container {
    background:#dde5e9;
}
</style>